import * as types from './actionTypes'

export function setBranchTabs(branchTab) {
  return { type: types.BRANCH_TABS, branchTab }
}
